import { z } from 'zod';
// --- Traffic allocation per experiment within a group ---
export const groupAllocationSchema = z
    .object({
    experiment_id: z
        .string()
        .min(1)
        .meta({ description: 'Experiment that receives this traffic range' }),
    range_start: z
        .number()
        .int()
        .min(0)
        .max(9999)
        .meta({ description: 'Start of bucket range (inclusive, 0-9999)' }),
    range_end: z
        .number()
        .int()
        .min(1)
        .max(10000)
        .meta({ description: 'End of bucket range (exclusive, 1-10000)' }),
})
    .meta({
    id: 'GroupAllocation',
    description: 'Traffic allocation range for one experiment within an exclusion group',
});
// --- Contiguous range validator (reused in create + update) ---
function validateContiguousRanges(allocs) {
    const sorted = [...allocs].sort((a, b) => a.range_start - b.range_start);
    if (sorted[0]?.range_start !== 0)
        return false;
    for (let i = 1; i < sorted.length; i++) {
        if (sorted[i]?.range_start !== sorted[i - 1]?.range_end)
            return false;
    }
    return sorted[sorted.length - 1]?.range_end === 10000;
}
const CONTIGUOUS_RANGE_ERROR = 'Allocations must be contiguous ranges covering 0-10000';
// --- Create exclusion group request ---
export const createExclusionGroupRequestSchema = z
    .object({
    name: z.string().min(1).max(200).meta({ description: 'Human-readable group name' }),
    description: z
        .string()
        .max(2000)
        .meta({ description: 'Optional description of the exclusion group purpose' })
        .optional(),
    allocations: z
        .array(groupAllocationSchema)
        .meta({
        description: 'Traffic allocations (2-20, must be contiguous ranges covering 0-10000)',
    })
        .min(2)
        .max(20)
        .refine(validateContiguousRanges, { error: CONTIGUOUS_RANGE_ERROR }),
})
    .meta({
    id: 'CreateExclusionGroupRequest',
    description: 'Create a mutual exclusion group ensuring no visitor is in multiple experiments',
});
// --- Update exclusion group request ---
export const updateExclusionGroupRequestSchema = z
    .object({
    name: z.string().min(1).max(200).optional(),
    description: z.string().max(2000).optional(),
    allocations: z
        .array(groupAllocationSchema)
        .min(2)
        .max(20)
        .refine(validateContiguousRanges, { error: CONTIGUOUS_RANGE_ERROR })
        .optional(),
})
    .meta({
    id: 'UpdateExclusionGroupRequest',
    description: 'Update an exclusion group (all fields optional)',
});
//# sourceMappingURL=exclusion-groups.js.map